import * as React from 'react'
import type { IErrors } from 'pages/templates/templates'
import type PanelItemType from './settings-panel.d'
import { TEMPLATES_FORM_BUTTON_DELETE } from 'core/constants/translations/template'
import { GROUPS_SPORT_FORM_BUTTON_DELETE, GROUPS_STORE_FORM_BUTTON_DELETE } from 'core/constants/translations/groups'
import { useTranslation } from 'react-i18next'

export interface IPanelFooterProps {
  onClose: () => void
  item: PanelItemType
  onSaveItem: () => void
  isSaveDisabled: boolean
  errors?: IErrors
  canEdit: boolean
  showDeleteConfirm: () => void
  groupType: string
}

const PanelFooter = ({
  onClose,
  item,
  onSaveItem,
  isSaveDisabled,
  canEdit,
  showDeleteConfirm,
  groupType
}: IPanelFooterProps) => {
  const { t } = useTranslation()
  const isNew = React.useMemo(() => item && !item.id, [item])

  return item ? (
    <div className="mg-groups-footer">
      <div className="mg-groups-footer__left">
        {canEdit && item && item.id ? (
          <button
            type="button"
            className="vtmn-btn vtmn-btn_size--small vtmn-btn_variant--secondary mg-button-delete"
            onClick={showDeleteConfirm}
          >
            {groupType === 'Store' && t(GROUPS_STORE_FORM_BUTTON_DELETE)}
            {groupType === 'Sport' && t(GROUPS_SPORT_FORM_BUTTON_DELETE)}
            {groupType === 'Template' && t(TEMPLATES_FORM_BUTTON_DELETE)}
          </button>
        ) : null}
      </div>
      <div className="mg-groups-footer__right">
        <button type="button" className="vtmn-btn vtmn-btn_variant--secondary vtmn-btn_size--small" onClick={onClose}>
          {t('cancel')}
        </button>
        <button
          type="button"
          data-testid="mg-sports-group-save"
          className="vtmn-btn vtmn-btn_size--small"
          {...(!isSaveDisabled && { onClick: onSaveItem })}
          disabled={isSaveDisabled}
        >
          {isNew ? t('add') : t('save')}
        </button>
      </div>
    </div>
  ) : null
}

export default PanelFooter
